import React, { Component } from 'react'
import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'
import { Link } from 'react-router-dom'
import withUserData from 'src/components/auth/withUserData'
import { UserDataContext } from 'src/components/auth/withAuth'
import { AuthApi } from 'src/api/authApi'
import ImpersonateOrganizationMenu from './ImpersonateOrganizationMenu'

const AvatarButton = React.forwardRef((props, ref) => {
    const { userData, defaultOrg, ...rest } = props
    return (
        <Button {...rest}>
            <div className={'user-data-wrapper'}>
                <span className={'user-first-last-name'}>
                    {userData.firstName} {userData.lastName}
                </span>
                <UserDataContext.Consumer>
                    {value => {
                        if (value.impersonatedOrganization || defaultOrg) {
                            return (
                                <span className="impersonated-tenant">
                                    {value.impersonatedOrganization?.label ||
                                        defaultOrg.name}
                                </span>
                            )
                        }
                    }}
                </UserDataContext.Consumer>
            </div>
            <Icon icon={'user-outline'} />
            <Icon className={'chevron-down'} icon={'chevron-down'} />
        </Button>
    )
})

class UserMenu extends Component {
    static contextType = UserDataContext

    state = { defaultOrg: null }
    authApi = new AuthApi(this.context.authToken)

    componentDidMount() {
        this.loadDefaultOrg()
    }

    async loadDefaultOrg() {
        const { data } = await this.authApi.fetchTenants(
            this.context.data.username
        )
        const defaultOrg = data.tenants.find(
            organization =>
                organization.organization_id ===
                this.context.data.organization_id
        )
        this.setState({ defaultOrg })
    }

    render() {
        const { userData } = this.props
        return (
            <Dropdown className={'login-menu'} alignRight>
                <Dropdown.Toggle
                    as={AvatarButton}
                    id="user-dropdown-menu"
                    userData={userData}
                    defaultOrg={this.state.defaultOrg}
                />
                <Dropdown.Menu>
                    <ImpersonateOrganizationMenu apiClient={this.authApi} />
                    <Dropdown.Divider />
                    <Link className={'stix-dropdown-item'} to="/logout">
                        Logout
                    </Link>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

export default withUserData(UserMenu)
